import React, { useEffect, useState } from 'react';
export function UrgencyTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 71,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 bg-navy-dark text-white px-4 border-y border-white/10" data-id="element-329">
      <div className="max-w-4xl mx-auto text-center" data-id="element-330">
        <div className="inline-block bg-red-500 text-white font-bold px-4 py-1 rounded-full text-sm mb-6 animate-pulse" data-id="element-331">
          ⚠️ OFERTA DE LANZAMIENTO EN VIVO
        </div>

        <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-332">
          +$15.000 después de que termine este período
        </h2>

        <p className="text-lg text-slate-300 mb-8 max-w-2xl mx-auto" data-id="element-333">
          El precio actual es exclusivo de lanzamiento. Cuando el contador
          llegue a cero, el precio sube y no vuelve a bajar.
        </p>

        <div className="flex justify-center gap-4 md:gap-8 mb-10" data-id="element-334">
          <div className="flex flex-col items-center" data-id="element-335">
            <div className="bg-navy border border-white/20 w-20 h-24 md:w-24 md:h-28 rounded-xl flex items-center justify-center text-4xl md:text-5xl font-bold text-sky shadow-lg" data-id="element-336">
              {String(timeLeft.hours).padStart(2, '0')}
            </div>
            <span className="text-slate-400 mt-2 text-sm uppercase tracking-wider" data-id="element-337">
              Horas
            </span>
          </div>
          <div className="text-4xl md:text-5xl font-bold text-sky mt-4 md:mt-6" data-id="element-338">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-339">
            <div className="bg-navy border border-white/20 w-20 h-24 md:w-24 md:h-28 rounded-xl flex items-center justify-center text-4xl md:text-5xl font-bold text-sky shadow-lg" data-id="element-340">
              {String(timeLeft.minutes).padStart(2, '0')}
            </div>
            <span className="text-slate-400 mt-2 text-sm uppercase tracking-wider" data-id="element-341">
              Minutos
            </span>
          </div>
          <div className="text-4xl md:text-5xl font-bold text-sky mt-4 md:mt-6" data-id="element-342">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-343">
            <div className="bg-navy border border-white/20 w-20 h-24 md:w-24 md:h-28 rounded-xl flex items-center justify-center text-4xl md:text-5xl font-bold text-sky shadow-lg" data-id="element-344">
              {String(timeLeft.seconds).padStart(2, '0')}
            </div>
            <span className="text-slate-400 mt-2 text-sm uppercase tracking-wider" data-id="element-345">
              Segundos
            </span>
          </div>
        </div>

        <div className="max-w-md mx-auto mb-8" data-id="element-346">
          <div className="flex justify-between text-sm mb-2 text-slate-300" data-id="element-347">
            <span data-id="element-348">68% completado</span>
            <span data-id="element-349">68% de cupos tomados</span>
          </div>
          <div className="w-full bg-white/10 rounded-full h-3" data-id="element-350">
            <div className="bg-sky h-3 rounded-full" style={{
            width: '68%'
          }} data-id="element-351"></div>
          </div>
        </div>

        <button onClick={scrollToPricing} className="bg-white text-navy hover:bg-slate-100 font-bold text-lg px-8 py-4 rounded-xl transition-all shadow-lg" data-id="element-352">
          VER OPCIONES DE COMPRA →
        </button>

        <p className="text-xs text-slate-500 mt-6" data-id="element-353">
          El precio sube automáticamente al terminar el contador
        </p>
      </div>
    </section>;
}